import styled, { css } from "styled-components";
import { P2 } from "../styles";
import Spring from "../../components/Spring";
import { IWayWrapperStyleProps } from "./interfaces";

export const StyledSpring = styled(Spring)`
    margin-top: 50px;
    background-color: ${p => p.theme.c.snow};
`;

export const StyledCenter = styled.div`
    text-align: center;
    max-width: 800px;
    margin: auto;
`;

export const Alert = styled(P2)`
    background-color: ${p => p.theme.c.info};
    max-width: 460px;
    padding: 6px;
    margin: auto;
    border-radius: 8px;
    box-shadow: 0 0 5px 1px ${p => p.theme.c.blackShadow1};
    color: white;
    margin-bottom: 20px;
    text-shadow: 0 0 3px ${p => p.theme.c.blackShadow2};

    .i-alert {
        font-size: 18px;
        position: relative;
        top: 2px;
    }
`;

export const BigIcon = styled.span`
    transform: scale(1.3);
    display: inline-block;

    .i-homework {
        position: relative;
        top: 1px;
        font-size: 34px;
    }
`;

export const WayWrapper = styled.div<IWayWrapperStyleProps>`
    display: flex;
    text-align: left;
    max-width: 620px;
    margin: auto;

    .link {
        color: ${p => p.theme.c.snowOnActive};
    }

    ${p =>
        p.isLast &&
        css`
            margin-bottom: 20px;
        `}
`;

export const Way = styled.div`
    background-color: ${p => p.theme.c.info};
    height: 60px;
    width: 60px;
    margin: auto;
    border-radius: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    margin-right: 20px;

    [class^="i-"] {
        display: block;
        font-size: 36px;
        color: ${p => p.theme.c.whiteOnActive};
    }
`;

export const StyledForm = styled.div`
    background: ${p => p.theme.c.white};
    padding: 20px;
    padding: 24px;
    margin: 12px;
    border-radius: 8px;
    box-shadow: 0 3px 9px ${p => p.theme.c.blackShadow1};
    pointer-events: none;
    opacity: 0.8;
`;

export const StyledSection = styled.div`
    display: flex;
    margin-top: 20px;
    ${p =>
        p.theme.sm.min(css`
            p {
                padding: 0 20px;
            }
        `)}
    ${p =>
        p.theme.lg(css`
            > div {
                display: inline-block;
                width: 33.3%;
                box-sizing: border-box;
            }
            > section {
                display: inline-block;
                width: 66.6%;
                box-sizing: border-box;
            }
        `)}
    
    ${p =>
        p.theme.md.max(css`
            flex-direction: column;
            align-items: center;
            font-size: 16px;
        `)}
`;

export const StyledTexts = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;

    &.inClass {
        h3 {
            margin-bottom: 6px;
        }
        ul {
            margin-top: 6px;
        }
    }
`;

export const Advice = styled(Alert)`
    max-width: 840px;
    margin-top: 20px;
    text-align: center;
`;

export const Image = styled.img`
    width: 100%;
    box-shadow: 0 0 5px 1px ${p => p.theme.c.blackShadow2};
    display: block;
`;

export const MenuWrapper = styled.div`
    ${p =>
        p.theme.sm.min(css`
            padding: 0 20px;
        `)}
`;

export const SimpleWaysWrapper = styled.div`
    display: flex;
    justify-content: center;
    margin-top: 10px;
    section {
        display: flex;
    }
    section > div {
        display: flex;
        justify-content: center;
        margin: 0 20px 30px 40px;
        &:first-child {
            margin-left: 0;
        }
        ${p =>
            p.theme.xs(css`
                div {
                    margin-left: 0;
                }
                margin: 0 0 12px 0;
                justify-content: flex-start;
            `)}
    }
    ${p =>
        p.theme.xs(css`
            section {
                justify-content: flex-start;
                flex-direction: column;
                margin-bottom: 12px;
            }
        `)}
`;

export const ConnectWrapper = styled.div`
    box-shadow: 0 3px 9px ${p => p.theme.c.blackShadow3};
    padding: 18px;
    padding-top: 24px;
    box-sizing: border-box;
    margin: 20px 10px;
    border-radius: 6px;
    background-color: ${p => p.theme.mode === "dark" ? p.theme.c.white : p.theme.c.snow};
`;
